import { QueovalBase, StreamUpload } from '../global';
import { ParamsMedia, MediaModel } from './media.model';


export class ParamsMediaModel extends QueovalBase {
  public Value: ParamsMedia;
}

export class UploadMediaModel extends QueovalBase {
  public StreamUpload: StreamUpload;
  public Media: MediaModel
}
